/**
 * /settings — the Settings home: search, Company band, Modules band.
 * (Used to redirect to the first page; spec 2026-11-02 §2.)
 */

import { createFileRoute } from "@tanstack/react-router";
import { SettingsHome } from "@/components/settings/settings-home";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/settings/")({
  component: SettingsHome,
});
